<script setup>
  defineProps({
    id: { type: Number, default: null },
    task: { type: Object, default: null },
  });
</script>

<template>
  <v-list-item class="px-2 rounded" :to="`/tasks/due/${id}`">
    <v-list-item-title class="text-wrap pr-4">
      <span v-if="task.episode_monitoring_task_id" />
      {{ task.short_description }} ({{ $t(`tasks.category.${task.category}`) }})
    </v-list-item-title>
    <template #append>
      <v-list-item-action end>
        <v-icon icon="mdi-plus-circle" color="primary" />
      </v-list-item-action>
    </template>
  </v-list-item>
</template>
